import { getCategories } from "@/helpers/server-actions/common-collections";
import { getSpeakers } from "@/helpers/server-actions/speakers-collection";
import { Category } from "@/models/category";
import { Speaker } from "@/models/speaker";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


interface DashboardState {
    selectedCategory: string;
    categories: Category[];
    speakers: Speaker[];
    gradient: string;
    loading: boolean;
}

const initialState: DashboardState = {
    selectedCategory: "all",
    gradient: "all-gradient-background",
    categories: [],
    speakers: [],
    loading: false,
};

// create async thunk to fetch categories
export const fetchCategories = createAsyncThunk(
    "dashboard/fetchCategories",
    async () => {
        const response = await getCategories();
        return response;
    }
);

// create async thunk to fetch speakers
export const fetchSpeakers = createAsyncThunk(
    "dashboard/fetchSpeakers",
    async () => {
        const allSpeakers = await getSpeakers();
        const activeSpeakers = allSpeakers.filter((speaker) => !speaker.isCanceled);
        return activeSpeakers;
    }
);

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
            state.gradient = action.payload + "-gradient-background";
            state.categories = state.categories.map((category) => {
                if (category.slug === action.payload) {
                    return { ...category, selected: true };
                } else {
                    return { ...category, selected: false };
                }
            });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCategories.fulfilled, (state, action) => {
            state.categories = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchCategories.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCategories.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(fetchSpeakers.fulfilled, (state, action) => {
            state.speakers = action.payload;
            state.loading = false;
        });
        builder.addCase(fetchSpeakers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSpeakers.rejected, (state) => {
            state.loading = false;
        });
        
    },
});

export const { setSelectedCategory } = dashboardSlice.actions;
export default dashboardSlice.reducer;